// src/screens/Auth/TokenHandlerScreen.tsx
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LoginWithFirebaseToken } from "../../actions/AuthActions"; // create this in next step

const TokenHandlerScreen = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      dispatch<any>(LoginWithFirebaseToken(token));
    }
  }, [token]);

  return <p>جارٍ تسجيل الدخول...</p>;
};

export default TokenHandlerScreen;
